export default __webpack_public_path__ + "static/media/aranjamenteFlorale.d162932d.jpg";